/**
 * UrlTranslator is copy one to one
 * from sportsbook-api should be
 * temporary solution
 */

import { get } from '../../utils';

/**
 * Translate urls for provided dictionary
 * @param {object} urlDictionary
 * @constructor
 */
var UrlTranslator = function UrlTranslator(urlDictionary) {
    this.urlDictionary = urlDictionary;
};

UrlTranslator.prototype._matchLanguageChunk = function (url, fromLanguage, toLanguage) {
    return url.match(
        new RegExp('^(.*[^/]+\/' + fromLanguage + '|' + toLanguage + '\/)(.*)$')
    );
};

UrlTranslator.prototype._translateLanguageChunk = function (languageChunk, fromLanguage, toLanguage) {
    return languageChunk.replace(fromLanguage, toLanguage);
};

UrlTranslator.prototype._getTranslatedSlug = function (slug, fromLang, toLang) {
    var translations = get(this.additionalTranslations, 'slugTranslations', undefined);
    if (translations === undefined) {
        return false;
    }

    var engSport = get(translations.slugs, fromLang + '.' + slug, false);
    if (engSport !== false) {
        return get(translations.slugsRev, toLang + '.' + engSport, false);
    }
    return get(translations.slugsRev, toLang + '.' + slug, false);
};

UrlTranslator.prototype._translatePath = function (path, fromLang, toLang) {
    const chunks = (path.split('/') || []).filter(Boolean);

    const translatedPath = chunks.map((pathChunk) => {
        const splitPathChunk = pathChunk.split('?')[0];
        const lowCaseChunk = splitPathChunk.toLocaleLowerCase();
        const engChunkTranslation = get(this.urlDictionary, `${fromLang}.localToEng.${lowCaseChunk}`, pathChunk);
        const translatedChunk = get(this.urlDictionary, `${toLang}.engToLocal.${engChunkTranslation}`, false);

        if (translatedChunk) {
            return translatedChunk;
        }
        return this._getTranslatedSlug(lowCaseChunk, fromLang, toLang) || engChunkTranslation;
    }).join('/');
    return `/${translatedPath}`;
};

/**
 * Main method for url translation
 * @param {string} url - to translate
 * @param {string} fromLanguage - source language code for example 'en-gb'
 * @param {string} toLanguage - destination language code example 'de-de'
 * @param {boolean} [languageChunk=false] - transform url language code chunk, for example
 * from ../en-gb/sports/.. to ../de-de/sports/..
 * @param {object} [additionalTranslations={}] - Additional translations
 * @returns {string} url - translated url
 */
UrlTranslator.prototype.translate = function (
    url,
    fromLanguage,
    toLanguage,
    languageChunk = false,
    additionalTranslations
) {
    this.additionalTranslations = additionalTranslations || {};

    const queryParams = url.split('?')[1];
    const hasEndingSlash = url.endsWith('/');
    const postfix = `${hasEndingSlash ? '/' : ''}${queryParams ? `?${queryParams}` : ''}`;

    const match = this._matchLanguageChunk(url, fromLanguage, toLanguage);
    if (!match) {
        const [httpPart, noProtocolUrl] = (url.startsWith('http') ? url.split('//') : ['', url]);
        const prefix = httpPart ? `${httpPart}/` : '';
        return `${prefix}${this._translatePath(noProtocolUrl, fromLanguage, toLanguage)}${postfix}`;
    }
    if (languageChunk) {
        const translatedUpToLanguageChunk = this._translateLanguageChunk(match[1], fromLanguage, toLanguage);
        const translatedPathAfterLangChunk = this._translatePath(match[2], fromLanguage, toLanguage);
        return `${translatedUpToLanguageChunk}${translatedPathAfterLangChunk}${postfix}`;
    }
    return `${match[1]}${this._translatePath(match[2], fromLanguage, toLanguage)}${postfix}`;
};

export default UrlTranslator;
